import { Link } from "react-router-dom";

export const InternalServerError = () => {

    return (
        <>

            <div className="content-page">
                <div className="content">
                    <div className="container-fluid">
                        <div>
                            <div className="centrado-vertical-error">
                                <div className="col-md-12 text-center" style={{ paddingTop: "60px" }}>
                                    <h1>500</h1>
                                    <h2>Error Interno del Servidor</h2>
                                    <p>Póngase en contacto con el Administrador, por favor.</p>
                                    <Link to="/" className="btn btn-primary text-white boton-nuevo">Ir al Inicio</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
};